var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtaskControlRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4716 3.52925C12.7319 3.7896 12.7319 4.21171 12.4716 4.47206L8.94297 8.00066L12.4716 11.5293C12.7319 11.7896 12.7319 12.2117 12.4716 12.4721C12.2112 12.7324 11.7891 12.7324 11.5288 12.4721L8.00016 8.94347L4.47157 12.4721C4.21122 12.7324 3.78911 12.7324 3.52876 12.4721C3.26841 12.2117 3.26841 11.7896 3.52876 11.5292L7.05735 8.00066L3.52876 4.47206C3.26841 4.21171 3.26841 3.7896 3.52876 3.52925C3.78911 3.2689 4.21122 3.2689 4.47157 3.52925L8.00016 7.05785L11.5288 3.52925C11.7891 3.2689 12.2112 3.2689 12.4716 3.52925Z",
    fill: "#BA4E41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtaskControlRemove);
export default __webpack_public_path__ + "static/media/subtask-control-remove.c95bc1cc33694068a7dfd7bb37f3f8bf.svg";
export { ForwardRef as ReactComponent };